import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { default as React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DROPDOWN_FILTERS } from "../../DropdownConstants";
import { GET_ALL_FILTER } from "../../appConstants";
import "../../components/Headers/Header.css";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import HomeHeader from "../HomeHeader";
import "../HomeHeader.css";
import AddCustomFilter from "../Modal/AddCustomFilter";
import FilterModal from "../Modal/FilterModal";
import "../Modal/Modal.css";
import SideBar from "../SideBar/SideBar";
import DataTable from "../Tables/HomePatientTable";
import LoaderComponent from "./LoaderComponent/LoaderComponent";
const FilterTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loader, setloader] = useState(true);
  const [sortby, setsortby] = useState("");
  const [search, setsearch] = useState({});
  const [count, setCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [add, setAdd] = useState();
  const [showCustomFilter, SetCustomFilter] = useState(false);
  const [totalFieldList, setTotalFieldList] = useState([]);
  const [update, setUpdate] = useState(false);
  const [asc, setAsc] = useState(true);
  const [editData, setEditData] = useState({});
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [searchWord, setSearchWord] = useState("");
  const [deleteUpdate, setdeleteUpdate] = useState(false);

  const handleSearch = (e) => {
    setCount(1);
    const filterobj = { asc: asc, sort_by: sortby, keyword: e.target.value };
    setSearchWord(e.target.value);
    setsearch(filterobj);
  };
  const handlesort = (e) => {
    const filterobj = {
      asc: true,
      sort_by: e.target.value,
      keyword: searchWord,
    };
    setsortby(e.target.value);

    setsearch(filterobj);
  };

  const handlePageChange = (page) => {
    if (page >= 0 && page <= totalPages) {
      setCount(page + 1);
    }
  };
  const handleclick = () => {
    setAdd(true);
  };
  const handleModalClose = () => {
    SetCustomFilter(false);
    setAdd(false);
    setEditData({});
  };
  const handleCustomFilter = (fields) => {
    setTotalFieldList(fields);
    SetCustomFilter(true);
    setAdd(false);
  };
  const handleBackButton = (fields) => {
    setAdd(true);
    SetCustomFilter(false);
  };

  const handleOrder = () => {
    if (sortby !== "") {
      const filterobj = { asc: !asc, sort_by: sortby, keyword: searchWord };
      setsearch(filterobj);
      setAsc((asc) => !asc);
    }
  };

  const buttonstyles = {
    height: 39,
    width: 200,
    color: "black",
    backgroundColor: "#0FC4A0",
    position: "relative",
    top: 25,
    fontWeight: "bold",
    cursor: "pointer",
    fontFamily: "Montserrat",
  };
  useEffect(() => {
    const filterobj = search;

    const fetchData = async () => {
      setloader(false);
      try {
        const response = await axiosInstance.post(
          `${GET_ALL_FILTER}?page=${count}&size=10`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setData(response.data.items);
        setTotalPages(response.data.pages);
        setloader(true);
      } catch (error) {
        setloader(true);
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };

    fetchData();
  }, [search, count, update, deleteUpdate]);

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("authenticated");
    if (isAuthenticated !== "true") {
      navigate("/login");
    }
  });

  return (
    <div className="d-flex min-vh-100  background">
      <SideBar />
      <div>
        <HomeHeader />
        <div className="d-flex flex-column ">
          <div>
            <div className="header">
              <h1 className="header-text">FILTERS</h1>

              <div className="d-flex justify-content-between mb-5">
                <div className="d-flex justify-content-start gap-3">
                  <div>
                    <h6
                      style={{
                        fontFamily: "Montserrat",
                        color: "#0fc4a0",
                        fontSize: "14px",
                      }}
                    >
                      Sort by
                      <span style={{ color: "black" }}>&nbsp;||&nbsp;</span>
                      <span
                        style={{
                          color: "rgb(249, 215, 161)",
                          cursor: "pointer",
                        }}
                      >
                        <span
                          onClick={handleOrder}
                          style={{ fontFamily: "Montserrat" }}
                        >
                          {asc ? "Desc" : "Asc"}
                        </span>
                        {asc ? (
                          <i className="fa fa-sort-amount-asc"></i>
                        ) : (
                          <i className="fa fa-sort-amount-desc"></i>
                        )}
                      </span>
                    </h6>
                    <Select
                      displayEmpty
                      placeholder="Sort by"
                      className="sort"
                      name="Sort"
                      value={sortby || ""}
                      onChange={handlesort}
                      style={{ color: "white", height: "39px" }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            backgroundColor: "#121c1b",
                            color: "white",
                            borderRadius: "5px",
                            border: "1px solid #0fc4a0",
                          },
                        },
                      }}
                    >
                      <MenuItem value="" style={{ fontSize: "14px" }}>
                        Select
                      </MenuItem>
                      {data &&
                        data.length > 0 &&
                        DROPDOWN_FILTERS.map((option) => (
                          <MenuItem
                            key={option.label}
                            value={option.value}
                            style={{ fontSize: "14px" }}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </div>
                  <div className="mr-4 d-flex flex-column justify-content-between">
                    <h6
                      style={{
                        fontFamily: "Montserrat",
                        color: "#0fc4a0",
                        fontSize: "14px",
                      }}
                    >
                      Search
                    </h6>
                    <input
                      style={{ height: "39px" }}
                      type="search"
                      placeholder="Search here"
                      className="search"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>
                </div>
                <button
                  type="button"
                  className="btn  mr-4 shadow  btn-dataset"
                  style={buttonstyles}
                  onClick={handleclick}
                >
                  ADD
                </button>
              </div>
            </div>
            {loader ? (
              <div>
                <DataTable
                  handlePage={handlePageChange}
                  count={count}
                  totalPages={totalPages}
                  data={data}
                  type={"filtertable"}
                  setAdd={setAdd}
                  setEditData={setEditData}
                  deleteAlert={deleteAlert}
                  setDeleteAlert={setDeleteAlert}
                  setdeleteUpdate={setdeleteUpdate}
                />
              </div>
            ) : (
              <div
                className="d-flex align-items-center justify-content-between"
                style={{ margin: "10vw 48vw" }}
              >
                <div>
                  <LoaderComponent />
                </div>
              </div>
            )}
          </div>
          {add && (
            <FilterModal
              ModalState={add}
              handleClose={handleModalClose}
              setUpdate={setUpdate}
              editData={editData}
              handleCustomFilter={handleCustomFilter}
            />
          )}
          {showCustomFilter && (
            <AddCustomFilter
              ModalState={SetCustomFilter}
              handleClose={handleModalClose}
              handleBackButton={handleBackButton}
              totalFieldList={totalFieldList}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterTable;
